import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import FormattedDate from '../../../../../components/date/FormattedDate';
import { useNamespacedTranslation } from '../../../../../hooks/useNamespacedTranslation';
import { CompensationReview } from '../types';
import { CompensationReviewStatusBadge } from './CompensationReviewStatusBadge';

type Props = {
  review: CompensationReview;
};

const Field: React.FC<React.PropsWithChildren<{ label: string }>> = ({
  label,
  children,
}) => (
  <Col xs={6} md={3} className="mb-3 mb-md-0">
    <div className="text-muted small mb-1">{label}</div>
    <div className="fw-bold">{children}</div>
  </Col>
);

// Slim, read-only Information panel: only effective date, reference date,
// status and the assessing manager (detailed setup stays in Salesforce).
export const CompensationReviewInformation: React.FC<
  React.PropsWithChildren<Props>
> = ({ review }) => {
  const t = useNamespacedTranslation('compensationReviews.information');

  return (
    <Card className="mb-4">
      <Card.Body>
        <Row>
          <Field label={t('referenceDate')}>
            <FormattedDate day={review.referenceDate} format="short" />
          </Field>
          <Field label={t('effectiveDate')}>
            <FormattedDate day={review.effectiveDate} format="short" />
          </Field>
          <Field label={t('status')}>
            <CompensationReviewStatusBadge status={review.status} />
          </Field>
          <Field label={t('assessingManager')}>
            {review.assessingManager.name}
          </Field>
        </Row>
      </Card.Body>
    </Card>
  );
};
